'use client'

import { useEffect } from 'react'

/**
 * Bootstrap CDN base verir; client mount’ta settings refetch (idle kapısı yok).
 */
export default function MediaSettingsLoader() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    let cancelled = false

    const loadSettings = async () => {
      if (cancelled) return
      try {
        const { clearMediaUrlHelperCache, preloadMediaSettings } = await import(
          '@/lib/media-url-helper'
        )
        const { clearMediaSettingsCache } = await import('@/lib/media-settings')

        const w = window as Window & {
          __mediaCdnBaseUrl?: string
          __mediaAssetsBaseUrl?: string
          __mediaSettingsCache?: unknown
          __HABER_MEDIA_SETTINGS__?: unknown
        }

        const hasBootstrap = Boolean(w.__mediaCdnBaseUrl || w.__HABER_MEDIA_SETTINGS__)
        if (!hasBootstrap) {
          clearMediaUrlHelperCache()
          clearMediaSettingsCache()
        }

        await preloadMediaSettings()

        if (w.__mediaCdnBaseUrl) {
          try {
            localStorage.setItem('__mediaCdnBaseUrl', w.__mediaCdnBaseUrl)
          } catch {
            /* ignore */
          }
        }
        if (w.__mediaAssetsBaseUrl) {
          try {
            localStorage.setItem('__mediaAssetsBaseUrl', w.__mediaAssetsBaseUrl)
          } catch {
            /* ignore */
          }
        }
        if (w.__mediaSettingsCache) {
          try {
            localStorage.setItem('__mediaSettings', JSON.stringify(w.__mediaSettingsCache))
          } catch {
            /* ignore */
          }
        }

        window.dispatchEvent(new CustomEvent('mediaSettingsLoaded'))
      } catch (error) {
        console.warn('Failed to preload media settings:', error)
      }
    }

    void loadSettings()

    return () => {
      cancelled = true
    }
  }, [])

  return null
}
